import { SmallHeadline, ActionLink } from '@minted/fancyclothes';
import React, { memo } from 'react';
import isEqual from 'lodash/isEqual';
import {
  AccommodationDetails, Configuration, Section,
} from '../../../resources/modelTypes';
import { BLANK_SLATE_DOCUMENT } from '../../../core/constants';
import { DisplayPhoto } from '../DisplayPhoto';
import { RichTextContent } from '../../../content/components';

export type DisplayAccommodationSectionProps = {
  configuration: Configuration
  section: Section,
};

const DisplayAccommodationSection = ({
  configuration,
  section,
}: DisplayAccommodationSectionProps) => {
  const details = section.sectionDetails as AccommodationDetails;

  return (
    <>
      {
        section.photo && (
          <DisplayPhoto
            configuration={configuration}
            section={section}
          />
        )
      }
      <div data-cy="subheading">
        <SmallHeadline>
          {details.title}
        </SmallHeadline>
      </div>
      <div
        data-cy="body"
      >
        {
          details.content && !isEqual(details.content, BLANK_SLATE_DOCUMENT) && (
            <div>
              <RichTextContent value={details.content} />
            </div>
          )
        }
      </div>
      {
        (details.websiteUrl) && (
          <div>
            <ActionLink
              target="_blank"
              text={details.anchorText || 'Visit Website'}
              url={details.websiteUrl}
            />
          </div>
        )
      }
    </>

  );
};

const MemoizedDisplayAccommodationSection = memo(DisplayAccommodationSection);

export { MemoizedDisplayAccommodationSection as DisplayAccommodationSection };
